import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import FeatureBillPayment from "../../assets/img/FeatureBillPayment.svg"
import CONSTANTS from "../../services/constants.service";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";
import storefront from "../../services/storefront.service";
import ProgressPrompt from "./progressPrompt/progress-prompt-index";
import Helpers from "../../helpers/shared.helper";

let subscriptions = [];
const StorefrontSubHeader = ({
  isMobile = false,
  loadJoinNow = () => {},
  loadTopup = () => {},
  loadPayBills = () => {},
  loadSimDeactivation = () => {},
  menuToggle = () => {},
  activeSubMenu = null
}) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [quickService, setQuickService] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [services, setServices] = useState([]);

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  useEffect(() => {
    subscriptions.push(
        Storage.get_obsrv("bizConfigLoading").subscribe((data) => {
            if(!data) {
              const fetchedQuickServices = Helpers.getPOValue("quick_services_web_header", {"quickServices": []});
              if(fetchedQuickServices && fetchedQuickServices?.quickServices?.length > 0) {
                setServices(fetchedQuickServices?.quickServices);
              }
            }
        })
    );
    return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
                subscription.unsubscribe();
            }
        }
    }
  }, [])

  const handleQuickService = (type) => {
    if(isMobile) {
      menuToggle();
    }
    switch (type) {
      case CONSTANTS.QUICK_SERVICE.PAYBILLS:
        loadPayBills();
        break;
      case CONSTANTS.QUICK_SERVICE.QUICKTOPUP:
        loadTopup();
        break; 
      case CONSTANTS.QUICK_SERVICE.EAUCTION:
        localStorage.clear();
        window.location.href = Settings?.quick_links?.eauction;
        break; 
      case CONSTANTS.QUICK_SERVICE.JOINNOW:
        loadJoinNow()
        break;
      case CONSTANTS.QUICK_SERVICE.SIMDEACTIVATION:
        loadSimDeactivation();
        break;
      case CONSTANTS.QUICK_SERVICE.PROTECTIONCHANNEL:
        localStorage.clear();
        Storage.set("protection_channel_redirect", true, true);
        Storage.set("protection_channel_redirect_url", Settings?.quick_links?.protection_channel, true);
        Storage.set("protection_channel_step", true, true);
        Storage.set("active_static_route", CONSTANTS.QUICK_SERVICE.PROTECTIONCHANNEL, true);
        window.location.href = Settings?.quick_links?.protection_channel;
        break;
      case CONSTANTS.QUICK_SERVICE.ADVERTISEMENT:
        localStorage.clear();
        Storage.set("advertisement_redirect", true, true);
        Storage.set("advertisement_redirect_url", Settings?.quick_links?.advertisement, true);
        Storage.set("advertisement_step", true, true);
        Storage.set("active_static_route", CONSTANTS.QUICK_SERVICE.ADVERTISEMENT, true);
        window.location.href = Settings?.quick_links?.advertisement;
        break;
      default:
        break;
    }
    handleModal();
  }

  const handleModal = (e) => {
    setOpenModal((prev) => !prev);
  };

  const handleYes = () => {
    handleQuickService(quickService);
  }

  const handleServicePrompt = (type) => {
    setQuickService(type);
    handleModal();
  }

  return (
          <>
          {services.length > 0 ?
            <ul className="storefront-sub-header-container">
              {services.map((service, index) => {
                const [key, value] = Object.entries(service)[0];
                const title = service.title;
                const img = service.img;
                return (
                  value && (
                    <li
                      className={activeSubMenu !== key ? "inactive-sub-header" : "active-sub-header"} 
                      key={index} 
                      onClick={() => {
                        if(activeSubMenu !== key) {
                          handleServicePrompt(key)
                        }
                      }}
                    >
                      <span>{translationKeys[title] || key}</span>
                      <img 
                        src={
                        storefront.getPoImage(
                          "quick_service_images",
                          `${img}`
                        ) || FeatureBillPayment
                        }
                        alt=""
                      />
                    </li>
                  )
                );
              })}
            </ul> : ""}
            <ProgressPrompt handleModal={handleModal} openModal={openModal} handleYes={handleYes}/>
          </>
  );
};

export default StorefrontSubHeader;
